import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { actions } from 'store';
import { ConfirmButton } from 'components/common';

export default connect(state => state)(class extends Component {
  delete = async () => {
    const { themeId, updateThemes } = this.props;
    const response = await api.delete(`/admin/server-themes/${themeId}`);
    if (!response.data || !response.data.success) return false;
    await updateThemes();
    return true;
  }

  render() {
    const { messages } = this.props;

    return (
      <ConfirmButton
        actionText={messages.commonDelete}
        buttonIcon="trash-alt"
        buttonText={messages.commonDelete}
        category="danger"
        confirmText={messages.siteThemesDeleteConfirm}
        confirmTitle={messages.siteThemesDelete}
        onConfirm={this.delete}
        successMessage={messages.siteThemesDeleteSuccess}
        stopPropagation={true}
      />
    );
  }
});
